// Chakra imports
import {
  Button,
  FormControl,
  Text,
  Image,
  useColorModeValue,
  Grid,
  GridItem,
  Icon,
  Flex,
  Avatar,
} from "@chakra-ui/react";
import { isObject } from "@chakra-ui/utils";
import Card from "components/card/Card";
import { useDropzone } from "react-dropzone";
import PopOverAlert from "components/popAlert/popAlert";
import {
  atualizarImagemMultiFace,
  consultarImagemMultiFace,
  atualizarImagemMultiFaceForce,
  criarImagemMultiFace,
  criarImagemMultiFaceForce,
} from "config/apis/requests";
import { convertData, IsEmpty } from "config/functions";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  MdOutlineCameraAlt,
  MdOutlineNoPhotography,
  MdOutlineCheck,
  MdUpload,
} from "react-icons/md";
import Webcam from "react-webcam";

export default function Camera(props: {
  tipoGratuidade?: any;
  dataUser: any;
  handleFoto: any;
  cpfBusca: any;
  dtNascimento: any;
  nomeUser: any;
  cep: any;
  tipoDocumento: any;
}) {
  const {
    tipoGratuidade,
    dataUser,
    handleFoto,
    cpfBusca,
    dtNascimento,
    nomeUser,
    cep,
    tipoDocumento,
  } = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [image, setImage] = useState("");
  const bgBar = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  const textColorSecondary = "secondaryGray.600";
  const [dataRec, setDataRec] = useState("");
  const [nome, setNome] = useState("");
  const [errosList, setErrosList] = useState([]);
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusFotoMultiFace, setStatusFotoMultiFace] = useState("");
  const [imagem64, setImagem64] = useState(dataUser.base64Imagem);
  const [imageUpload, setImageUpload] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };
  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const newImage = () => {
    setImage("");
    handleFoto("");
    setStatusFotoMultiFace("");
  };

  const webcamRef = React.useRef(null);

  const perfisPermitidosForce = [
    "ADMINISTRADOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
  ];

  interface PerfisUsuario {
    perfis: string[]; // Suponha que 'perfis' seja uma matriz de strings
    // Outras propriedades do objeto usuário, se houver
  }

  const [recoverLoggedUser, setRecoverLoggedUser] = useState([
    JSON.parse(localStorage.getItem("user")),
  ]);
  const usuarios: PerfisUsuario[] = [
    // Suponha que você tenha um array de objetos do tipo 'PerfisUsuario' aqui
    {
      perfis: recoverLoggedUser[0]?.perfis,
      // Outras propriedades do usuário, se houver
    },
    // Outros objetos 'PerfisUsuario' aqui
  ];
  const algumUsuarioCompativelForce = usuarios.some((usuario) => {
    return usuario?.perfis?.some((perfil) =>
      perfisPermitidosForce.includes(perfil)
    );
  });

  useEffect(() => {
    setNome(nomeUser);
    setDataRec(dtNascimento);
    setStatusFotoMultiFace("");
    if (!IsEmpty(dataUser.base64Imagem)) {
      setImage("data:image/jpeg;base64," + dataUser.base64Imagem);
      setImagem64("data:image/jpeg;base64," + dataUser.base64Imagem);
      setImageUpload("data:image/jpeg;base64," + dataUser.base64Imagem);
    } else {
      setImage("");
      setImagem64("");
      setImageUpload("");
    }
  }, [nomeUser, dtNascimento, dataUser, cep, cpfBusca]);

  const tirarNovamente = () => {
    newImage();
    setImage("");
    setImagem64("");
    setImageUpload("");
    setStatusFotoMultiFace("");
    capture(dtNascimento, nomeUser);
  };

  const capture = React.useCallback(
    (dtNascimento, nomeUsuarioFoto) => {
      setImagem64("");
      if (webcamRef.current && dtNascimento) {
        const imageSrc = webcamRef.current.getScreenshot({
          width: 1080,
          height: 720,
        });

        setImage(imageSrc);
        setStatusFotoMultiFace("");
        setIsLoading(true);
        criarImagemMultiFace(
          imageSrc.replace("data:image/jpeg;base64,", ""),
          (cpfBusca || dataUser?.numeroDocumento).replace(/[^\d]+/g, ""),
          nomeUsuarioFoto,
          convertData(dtNascimento),
          tipoDocumento
        ).then(function (result) {
          if (!IsEmpty(result.error)) {
            setStatusFotoMultiFace(
              result?.descricao !== null
                ? "Imagem inválida: " + result?.descricao
                : "Imagem inválida: " +
                    (result?.descricao || result?.data?.description)
            );
          } else if (result.status === "faceCreated") {
            //imageSrc.replace("data:image/jpeg;base64,", "");
            setStatusFotoMultiFace("Foto válida!");
            handleFoto(imageSrc);
            setIsLoading(false);
          }
          setIsLoading(false);
        });
      }
    },
    [webcamRef]
  );
  const captureForce = React.useCallback(
    (dtNascimento, nomeUsuarioFoto) => {
      setImagem64("");
      if (webcamRef.current && dtNascimento) {
        const imageSrc = webcamRef.current.getScreenshot({
          width: 1080,
          height: 720,
        });

        setImage(imageSrc);
        setStatusFotoMultiFace("");
        setIsLoading(true);

        criarImagemMultiFaceForce(
          imageSrc?.replace("data:image/jpeg;base64,", ""),
          (
            cpfBusca.replace(/[^\d]+/g, "") ||
            dataUser?.numeroDocumento.replace(/[^\d]+/g, "")
          ).replace(/[^\d]+/g, ""),
          nomeUsuarioFoto,
          convertData(dtNascimento),
          true,
          tipoDocumento
        ).then(function (result) {
          if (!IsEmpty(result.error)) {
            setStatusFotoMultiFace(
              result.data.cause !== null
                ? "Imagem inválida: " + result.data.cause
                : "Imagem inválida: " + (result.descricao || result.description)
            );
          } else if (result.status === "faceCreated") {
            setStatusFotoMultiFace("Foto válida!");
            handleFoto(imageSrc);
            setIsLoading(false);
          }
          setIsLoading(false);
        });
      }
    },
    [webcamRef]
  );

  const videoConstraints = {
    width: 1080,
    height: 720,
    screenshotQuality: 1,
    facingMode: "user",
  };

  const maxSizeInBytes = 1 * 1024 * 1024;

  const { open, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setIsLoading(true);
      setStatusFotoMultiFace("");

      const file = acceptedFiles[0];

      if (file.size <= maxSizeInBytes) {
        const reader = new FileReader();
        reader.onloadend = () => {
          // A URL de dados da imagem é acessada aqui
          if (reader.result) {
            const fileContent = reader.result as string;
            setImage("");
            setImagem64("");
            try {
              criarImagemMultiFaceForce(
                fileContent.replace("data:image/jpeg;base64,", ""),
                (
                  cpfBusca || dataUser?.numeroDocumento.replace(/[^\d]+/g, "")
                ).replace(/[^\d]+/g, ""),
                nome || nomeUser,
                convertData(dtNascimento),
                true,
                tipoDocumento
              ).then(function (result) {
                if (
                  !IsEmpty(result?.error) ||
                  result?.status == 413 ||
                  result == 413
                ) {
                  setStatusFotoMultiFace(
                    result !== 413
                      ? result?.data?.cause !== null
                        ? "Imagem inválida: " + result.data.cause
                        : "Imagem inválida: " +
                          (result.descricao || result.description)
                      : " O arquivo enviado excede o limite permitido. Por favor, envie um arquivo menor."
                  );
                } else if (result.status === "faceCreated") {
                  setStatusFotoMultiFace("Foto válida!");
                  setImageUpload(fileContent);
                  setImage(fileContent);
                  setImagem64(fileContent);
                  handleFoto(fileContent);
                }
                setIsLoading(false);
              });
            } catch (error) {
              setIsLoading(false);
              setStatusFotoMultiFace("Imagem inválida: " + error);
              return null;
            }
          }
        };

        if (file) {
          reader.readAsDataURL(file);
        }
      } else {
        setIsLoading(false);
        setStatusFotoMultiFace("Imagem muito grande, reduza a imagem!");
      }
    },
    noClick: true,
    noKeyboard: true,
  });

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      <FormControl {...dataUser}>
        <Grid
          h="100px"
          w="100%"
          templateRows={"repeat(2, 1fr)"}
          templateColumns={"repeat(5, 1fr)"}
          gap={1}
        >
          <GridItem rowSpan={2} colSpan={3}>
            {statusFotoMultiFace !== "Foto válida!" ||
            IsEmpty(dataUser) ||
            (IsEmpty(image) && IsEmpty(imagem64) && IsEmpty(imageUpload)) ? (
              <>
                <Flex direction={"column"} alignItems={"center"}>
                  <Card
                    mr="12px"
                    width={image || imagem64 || imageUpload ? "60%" : "100%"}
                    bg={bgBar}
                    alignItems={"center"}
                    borderRadius="250px"
                  >
                    {image || imagem64 || imageUpload ? (
                      <Avatar
                        src={imagem64 || image || imageUpload}
                        h="250px"
                        w="250px"
                        style={{ cursor: "pointer" }}
                        borderRadius={"100%"}
                      ></Avatar>
                    ) : (
                      <>
                        <Image
                          style={{
                            width: "250px",
                            borderRadius: "250px",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                          width="250px"
                          borderRadius="250px"
                          //src={`data:image/jpeg;base64,${dataUser.base64Imagem}`}
                          src={imagem64 || image || imageUpload}
                          objectFit="scale-down"
                          height="250"
                        />
                        <Webcam
                          style={{ borderRadius: 200 }}
                          audio={false}
                          mirrored={true}
                          imageSmoothing={true}
                          ref={webcamRef}
                          height={720}
                          width={1080}
                          screenshotFormat="image/jpeg"
                          videoConstraints={videoConstraints}
                        />
                      </>
                    )}
                  </Card>
                </Flex>
                {statusFotoMultiFace === "" ? null : (
                  <Text
                    fontSize="md"
                    color={
                      statusFotoMultiFace !== "Foto válida!"
                        ? "red.500"
                        : "green.500"
                    }
                    fontWeight="700"
                  >
                    <Icon
                      as={
                        statusFotoMultiFace !== "Foto válida!"
                          ? MdOutlineNoPhotography
                          : MdOutlineCheck
                      }
                      width="25px"
                      height="25px"
                      color="inherit"
                    />
                    {statusFotoMultiFace}
                  </Text>
                )}
              </>
            ) : (
              <>
                <Flex direction={"column"} alignItems={"center"}>
                  <Card
                    bg="green.300"
                    width={IsEmpty(dataUser) ? "60%" : "60%"}
                    borderRadius="250px"
                    alignItems={"center"}
                  >
                    <Image
                      width="250px"
                      borderRadius="250px"
                      src={image || imageUpload || imagem64}
                      objectFit="cover"
                      height="250"
                    />
                  </Card>
                  <Text
                    fontSize="md"
                    color={
                      statusFotoMultiFace !== "Foto válida!"
                        ? "red.500"
                        : "green.500"
                    }
                    fontWeight="700"
                  >
                    <Icon
                      as={
                        statusFotoMultiFace !== "Foto válida!"
                          ? MdOutlineNoPhotography
                          : MdOutlineCheck
                      }
                      width="20px"
                      height="20px"
                      color="inherit"
                    />{" "}
                    {statusFotoMultiFace}
                  </Text>
                </Flex>
              </>
            )}
          </GridItem>

          <>
            <GridItem colSpan={2}>
              <>
                <Text color={textColor} fontSize="20" fontWeight="400">
                  Enquadre o face no centro da câmera!
                  <Text
                    fontSize="md"
                    color={textColorSecondary}
                    fontWeight="300"
                  >
                    Para melhor definição, tire a foto com o cliente parado
                  </Text>
                </Text>

                {/* */}
              </>
            </GridItem>
            {IsEmpty(image) && IsEmpty(imagem64) && IsEmpty(imageUpload) ? (
              <GridItem colSpan={2}>
                <Button
                  colorScheme="green"
                  fontSize="sm"
                  mt="20px"
                  w={image || imageUpload || imagem64 ? "50%" : "40%"}
                  borderRadius="16px"
                  p="25px"
                  disabled={
                    IsEmpty(nomeUser) && IsEmpty(dataRec) ? true : false
                  }
                  isLoading={isLoading}
                  leftIcon={<MdOutlineCameraAlt size="20px" />}
                  onClick={() => capture(dtNascimento, nomeUser)}
                >
                  {image || imageUpload || imagem64
                    ? "Atualizar foto"
                    : "Tirar foto"}
                </Button>
                {algumUsuarioCompativelForce && (
                  <Button
                    colorScheme="orange"
                    fontSize="sm"
                    mt="20px"
                    ml="20px"
                    w="40%"
                    borderRadius="16px"
                    p="25px"
                    disabled={
                      IsEmpty(nomeUser) && IsEmpty(dtNascimento) ? true : false
                    }
                    isLoading={isLoading}
                    leftIcon={<MdOutlineCameraAlt size="20px" />}
                    onClick={() => captureForce(dtNascimento, nomeUser)}
                  >
                    Forçar foto
                  </Button>
                )}

                {algumUsuarioCompativelForce && (
                  <>
                    <input {...getInputProps()} />

                    <Button
                      colorScheme="blue"
                      fontSize="sm"
                      mt="20px"
                      w="50%"
                      borderRadius="16px"
                      p="25px"
                      isLoading={isLoading}
                      leftIcon={<MdUpload size="20px" />}
                      onClick={open}
                    >
                      Upload de foto
                    </Button>
                  </>
                )}
              </GridItem>
            ) : (
              <GridItem colSpan={2}>
                <Button
                  colorScheme="green"
                  fontSize="sm"
                  mt="30px"
                  w="50%"
                  borderRadius="16px"
                  p="25px"
                  isLoading={isLoading}
                  leftIcon={<MdOutlineCameraAlt size="20px" />}
                  onClick={tirarNovamente}
                >
                  Tirar novamente
                </Button>
              </GridItem>
            )}
          </>
        </Grid>
      </FormControl>
    </>
  );
}
